import { uniqBy } from 'lodash';
import type { Team, User } from 'api/models';
import type {
  ProjectTemplateProjectPhase,
  ProjectTemplateTask,
} from 'data/templates/projects';
import type { TemplateAssignee } from '../types';

export const filterUncreatedTasks = (
  tasks: ProjectTemplateTask[],
): ProjectTemplateTask[] => tasks.filter(({ isNew }) => !isNew);

export const getAllAssignees = (
  allTasks: ProjectTemplateTask[],
): TemplateAssignee =>
  filterUncreatedTasks(allTasks).reduce(
    (assignees, task) => {
      return {
        users: uniqBy(
          assignees.users.concat(task.assignee?.users ?? []),
          'userId',
        ),
        teams: uniqBy(
          assignees.teams.concat(task.assignee?.teams ?? []),
          'teamId',
        ),
      };
    },
    { users: [], teams: [] } as TemplateAssignee,
  );

export const getAllPhaseAssignees = (
  allPhases: ProjectTemplateProjectPhase[],
) =>
  allPhases.reduce(
    (allAssignees, phase) => {
      if (phase.isNew) {
        return allAssignees;
      }

      return {
        users: uniqBy(
          allAssignees.users.concat(
            phase.assignees?.reduce<User[]>((acc, x) => {
              if (x.user?.userId != null) {
                acc.push(x.user as User);
              }

              return acc;
            }, []) ?? [],
          ),
          'userId',
        ),
        teams: uniqBy(
          allAssignees.teams.concat(
            phase.assignees?.reduce<Team[]>((acc, x) => {
              if (x.team?.teamId != null) {
                acc.push(x.team as Team);
              }

              return acc;
            }, []) ?? [],
          ),
          'teamId',
        ),
      };
    },
    { users: [], teams: [] } as TemplateAssignee,
  );
